import generateObjectId from '@builttocreate/engine-utils/dist/generateObjectId';
import FieldTableColumnTypes from './FieldTableColumnTypes';

export default {
  collectionSchemaId: {
    title: 'Main Collection',
    root: true,
    children: [],
    tableColumns: [
      {
        _id: generateObjectId(),
        type: FieldTableColumnTypes.text,
        title: 'Text',
      },
      {
        _id: generateObjectId(),
        type: FieldTableColumnTypes.dropdown,
        title: 'Dropdown',
        options: [
          { _id: generateObjectId(), value: 'High' },
          { _id: generateObjectId(), value: 'Medium' },
          { _id: generateObjectId(), value: 'Low' }
        ]
      },
      {
        _id: generateObjectId(),
        type: FieldTableColumnTypes.image,
        title: 'Image',
        width: 0,
      },
    ]
  }
};

const generateRandomString = (length = 10) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

export const ChildCollectionSchema = {
  [generateRandomString()]: {
    title: 'ChildCollection',
    children: [],
    tableColumns: [
      {
        _id: generateObjectId(),
        type: FieldTableColumnTypes.text,
        title: 'Text',
      },
      {
        _id: generateObjectId(),
        type: FieldTableColumnTypes.dropdown,
        title: 'Dropdown',
        options: [
          { _id: generateObjectId(), value: 'High' },
          { _id: generateObjectId(), value: 'Medium' },
          { _id: generateObjectId(), value: 'Low' }
        ]
      },
      {
        _id: generateObjectId(),
        type: FieldTableColumnTypes.image,
        title: 'Image',
      },
    ]
  }
};
